import React from "react"
import EmailPresenterGeneral from "./tabs/EmailPresenterGeneral"
import EmailPresenterHistory from "./tabs/EmailPresenterHistory"

export default class EmailPresenterTabContent extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="tab-content">
        <EmailPresenterGeneral {...this.props} />
        <EmailPresenterHistory {...this.props} />
      </div>
    )
  }

}
